import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const Help_ScenarioNote = ({ type }) => {
    return (
        <Typography variant="body1" gutterBottom>
            <b>NOTE:</b> if the scenario crumb is shown these {type} are within that given scenario only.  (if no scenario crumb then they relate to the base client).<br /><br />
        </Typography>
    )
}

export const Help_setupAccounts = () => {
    return (
        <HelpWindow title="Setup Accounts" >
            <Help_ScenarioNote type="Accounts" />
            <Typography variant="body1" gutterBottom>
                Each section here allows you to enter different types of accounts that you may have. <br />
                All value entries are related to an account in some way.  This allows you to see in the grid and chart any of the accounts.<br />
                <br />
                <b>+</b> Creates a new account of the given type.  Note: if you copied a public/shared account, since it does not count towards your subscription total client count.  It has limited functionality, and You cannot create new accounts for a copied public/shared client.<br />
                <b>Edit</b> Allows you to edit the account and enter all the years of data for that account.  If you want  delete an account you can edit the account and delete all the years and submit.  That will delete the account.<br />
            </Typography>
        </HelpWindow>
    )
}

export const Help_setupRules = () => {
    return (
        <HelpWindow title="Setup Rules" >
            <Help_ScenarioNote type="Rules" />
            <Typography variant="body1" gutterBottom>
                <b>Desired Savings</b> are rules that you want to func from your annual <i>Gross*</i> account or that you may additionally want to fund from another account.  MyOwnFP does these savings calculations before taxes are calculated (since in the case you need to get additional money to fund those savings, that may cause a taxable sale event).  It doesn't matter if the Destination account here is a tax-deductible or not, that will be taken into account later.  Generally these rules are for where the destination account is a <i>Registered</i> account, as you often want to fund these even if you have to sell something from another account (ie <i>Gross*</i> might not be enough to satisfy the saving Rules).<br />
                <b>Surplus Savings</b> are for when you have extra annual <i>Surplus*</i> and how you want to distribute that <i>Surplus*</i>.<br />
                <b>Additional Income</b> are for those years when you might otherwise have a negative <i>Surplus*</i> (shortfall).  These rules determine what money should be taken from what accounts to ensure a 0 (or positive) <i>Surplus*</i>.<br />
                <br />
                <b>+</b> Creates a new rule of the given type<br />
                <b>Edit</b> Allows you to create all the entries for a given year.  Those rules will remain in future years until another year of rules is encountered.<br />
                <b>default</b> Indicates these are the default set of rules.  These may change over time as we improve the default rules.<br />
            </Typography>
        </HelpWindow>
    )
}